import { exact, string, bool, array, func } from 'prop-types';
import React, { useState } from 'react';
import { Toggle } from '../toggle/index';

export default function ToggleCustom( props ) {

    const { titleOn, title, startRight, labels, customFunc } = props.data;

    const [ toggle, setToggle ] = useState( startRight );

    return (
        <div className='toggle-group custom-toggle-group'>
            { titleOn && <div className='label'>{ title } </div> }

            <Toggle
                active={ toggle }
                setActive={ setToggle }
                labels={ labels }
                customFunc={ customFunc }
            />

        </div>
    );

}
ToggleCustom.propTypes = {
    data: exact( { titleOn: bool, title: string, startRight: bool, labels: array, customFunc: func } )
};